<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>排出事業者</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業者コード
            </div>
            <h4>{{ emission.code }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              会社名
            </div>
            <h4>{{ emission.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              マニフェスト区分
            </div>
            <h4>{{ emission.manifest_type | manifest_type_to_label }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              加入者番号
            </div>
            <h4>{{ emission.subscriber_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              所在地
            </div>
            <h4>〒{{ emission.zip_code }}&emsp;{{ emission.address }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ emission.phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
                <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              メールアドレス１
            </div>
            <h4>{{ emission.email_1 }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              担当名１
            </div>
            <h4>{{ emission.staff_1 }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              メールアドレス２
            </div>
            <h4>{{ emission.email_2 }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              担当名２
            </div>
            <h4>{{ emission.staff_2 }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <div class="overline">
              メモ欄
            </div>
            <h4>{{ emission.memo }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              排出者メール承認
            </div>
            <h4>{{ emission.approval_type | approval_type_to_label(emission.manifest_type, emission.approval_type) }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              リサイクル希望
            </div>
            <h4>{{ emission.use_recycle }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

      </v-card-text>

      <!-- DXE排出モード -->
      <template
        v-if="emission.manifest_type !== 'general_form' && !isEcContractSinglePlan"
      >
        <v-card-title class="subtitle-1 pt-0 pb-0">
          DXE排出モード
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-sheet outlined>
                <v-row>
                  <v-col cols="12" md="3">
                    <p class="subtitle-2 mb-1">招待日時</p>
                    <div class="body-2">
                      <span v-if="emission.send_invitation_at">{{ emission.send_invitation_at }}</span>
                      <span v-else class="grey--text">未招待</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <p class="subtitle-2 mb-1">ログインID</p>
                    <div class="body-2">
                      <span v-if="emission.login_id">{{ emission.login_id }}</span>
                      <span v-else class="grey--text">-</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <p class="subtitle-2 mb-1">前回ログイン日時</p>
                    <div class="body-2">
                      <span v-if="emission.last_login_at">{{ emission.last_login_at }}</span>
                      <span v-else class="grey--text">未ログイン</span>
                    </div>
                  </v-col>

                </v-row>
              </v-sheet>
            </v-col>
          </v-row>

        </v-card-text>
      </template>
      <!-- /DXE排出モード -->

      <v-card-text>

        <!-- 請求先 -->
        <v-row v-if="isBilling">
          <v-col cols="12" md="6">
            <div class="overline">
              請求先コード
            </div>
            <h4>{{ emission.billing_address_code }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              請求先名
            </div>
            <h4>{{ emission.billing_address_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /請求先 -->

        <!-- 表示順 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              表示順
            </div>
            <h4>{{ emission.sort_priority }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /表示順 -->

      </v-card-text>

      <!-- /排出事業者 -->
      <v-tabs
        v-model="emissionForm"
        background-color="blue lighten-4"
        centered
        icons-and-text
        fixed-tabs
      >
        <v-tabs-slider />

        <v-tab href="#tab-locations">
          事業場
          <v-icon>mdi-factory</v-icon>
        </v-tab>

        <v-tab href="#tab-persons">
          担当者
          <v-icon>mdi-account</v-icon>
        </v-tab>
        <v-tab
          href="#tab-entry_patterns"
        >
          登録パターン
          <v-icon>mdi-text-box-multiple-outline</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="emissionForm">
        <!-- 事業場 -->
        <v-tab-item value="tab-locations">
          <v-card class="mt-2" flat>
            <v-card-text>
              <v-sheet outlined rounded>
                <v-data-table
                  :headers="locationTableHeaders"
                  :items="emissionLocations"
                  :items-per-page="-1"
                  dense
                  disable-sort
                  hide-default-footer
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <span :title="item.name">{{ item.name | truncate(20) }}</span>
                  </template>
                  <template v-slot:[`item.address`]="{ item }">
                    <div>〒{{ item.zip_code }}</div>
                    <span>{{ item.address | truncate(25) }}</span>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card-text>
          </v-card>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="locationPage"
                :length="locationPagination.total_pages"
                :total-visible="locationTotalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="changePage"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- /事業場 -->

        <!-- 担当者 -->
        <v-tab-item value="tab-persons">
          <v-card class="mt-2" flat>
            <v-card-text>
              <v-sheet outlined rounded>
                <v-data-table
                  :headers="userTableHeaders"
                  :items="emissionUsers"
                  :items-per-page="-1"
                  dense
                  disable-sort
                  hide-default-footer
                >
                  <template v-slot:[`item.person_type`]="{ item }">
                    {{ item.person_type | emission_user_person_type_label }}
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card-text>
          </v-card>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="userPage"
                :length="userPagination.total_pages"
                :total-visible="userTotalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="emissionChangePage"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- /担当者 -->

        <!-- 登録パターン -->
        <v-tab-item value="tab-entry_patterns">
          <v-card class="mt-2" flat>
            <v-card-text>
              <v-sheet outlined rounded>
                <v-data-table
                  :headers="entryPatternTableHeaders"
                  :items="entryPatterns"
                  :items-per-page="-1"
                  dense
                  disable-sort
                  hide-default-footer
                >
                  <!-- 登録種別 -->
                  <template v-slot:[`item.order_type`]="{ item }">
                    <small>{{ item.order_type | short_order_type_label }}</small>
                  </template>
                  <!-- /登録種別 -->

                  <!-- パターン名 -->
                  <template v-slot:[`item.pattern_name`]="{ item }">
                    <div :title="item.name" class="line-clamp one-clamp">
                      {{ item.name }}
                    </div>
                    <div>
                      <small>{{ item.manifest_type | short_manifest_type_label }}</small>
                    </div>
                  </template>
                  <!-- /パターン名 -->

                  <!-- 排出事業場名 -->
                  <template v-slot:[`item.location`]="{ item }">
                    <div :title="item.emission_location_name" class="line-clamp one-clamp">
                      {{ item.emission_location_name }}
                    </div>
                  </template>
                  <!-- /排出事業場名 -->
                  <template v-slot:[`item.is_primary`]="{ item }">
                    {{ item.is_primary ? "●" : "" }}
                  </template>
                  <template v-slot:[`item.item`]="{ item }">
                    <div>
                      <v-chip
                        v-if="item.item_name"
                        :title="item.item_name"
                        color="#F0E6D0"
                        drak
                        label
                        x-small
                        class="chip-ellipsis"
                      >
                        <small>{{ item.item_name }}</small>
                      </v-chip>
                      <template v-else>&nbsp;</template>
                    </div>
                    <div>
                      <small>
                        {{ item.packing_name }}&nbsp;全{{ item.item_count }}件
                      </small>
                    </div>
                  </template>
                  <template v-slot:[`item.transport_route`]="{ item }">
                    <div :title="item.transport_route_name" class="line-clamp one-clamp">
                      {{ item.transport_route_name }}
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="line-clamp one-clamp"
                        >
                          {{ item.disposer_location_name }}
                        </div>
                      </template>
                      <div><strong>{{ item.disposer_name }}</strong></div>
                      <div>{{ item.disposer_location_name }}</div>
                      <div>{{ item.disposer_location_address }}</div>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-card-text>
            <v-row dense>
              <v-col>
                <v-pagination
                  v-model="entryPatternPage"
                  :length="entryPatternPagination.total_pages"
                  :total-visible="entryPatternTotalVisible"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="entryPatternPageChangeEvent"
                />
              </v-col>
            </v-row>
          </v-card>

        </v-tab-item>
        <!-- /登録パターン -->

      </v-tabs-items>
      <v-card-actions>
        <v-btn
          :disabled="isJwMode"
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="isJwMode"
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'DriverMasterEmissionShow',
  components: {
    Confirm
  },
  mixins: [
  ],
  data () {
    return {
      emissionForm: 'basicTab',
      breadcrumbs: [
        { text: '排出事業者一覧', disabled: false, to: '/driver/masters/emissions', exact: true },
        { text: '排出事業者詳細', disabled: true, to: '' },
      ],
      /* 排出事業者 **/
      emission: [],

      /* 事業場 **/
      emissionLocations: [],
      locationTableHeaders: [
        { value: 'code', text: '事業場コード' },
        { value: 'name', text: '事業場名' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'memo', text: 'メモ欄' },
        { value: 'sort_priority', text: '表示順', align: 'right' },
      ],
      locationPage: 1,
      locationTotalVisible: 7,
      locationPagination: {
        total_pages: 0,
        total_count: 0
      },

      /* 担当者 **/
      emissionUsers: [],
      userTableHeaders: [
        { value: 'code', text: '担当者コード' },
        { value: 'name', text: '担当者名' },
        { value: 'person_type', text: '担当者種別' },
        { value: 'emission_location_name', text: '担当者利用事業場' },
      ],
      userPage: 1,
      userTotalVisible: 7,
      userPagination: {
        total_pages: 0,
        total_count: 0
      },
      entryPatterns: [],
      entryPatternTableHeaders: [
        { value: 'order_type', text: '登録種別', width: '7%', align: 'center' },
        { value: 'pattern_name', text: 'パターン名\r\nマニ区分', width: '20%' },
        { value: 'location', text: '事業場', width: '23%' },
        { value: 'item', text: '取扱品目\r\n荷姿', width: '8%' },
        { value: 'transport_route', text: 'ルート\r\n処分事業場', width: '23%' },
        { value: 'sort_priority', text: '表示順', width: '4%' },
      ],
      entryPatternPage: 1,
      entryPatternTotalVisible: 7,
      entryPatternPagination: {
        total_pages: 0,
        total_count: 0
      },
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
      isEcContractSinglePlan: "use_ec_contract_single_plan",
    }),
  },
  created() {
    this.fetchEmission({ id: this.$route.params.id }).then((content) => {
      this.emission = content
    })

    this.searchEmissionLocations()
    this.searchEmissionUsers()
    this.searchEntryPatterns();
  },
  methods: {
    ...mapActions('DriverMasterEmission', {
      fetchEmission: 'show',
      deleteEmission: 'destroy',
    }),
    ...mapActions('DriverMasterEmissionLocation', {
      fetchEmissionLocations: 'index',
    }),
    ...mapActions('DriverMasterEmissionUser', {
      fetchEmissionUsers: 'index',
    }),
    ...mapActions("DriverMasterEmissionEntryPattern", {
      fetchEntryPatterns: "index"
    }),
    cancelButtonClickEvent () {
      this.$router.push({name: 'DriverMasterEmissions'})
    },
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterEmissionEdit', params: { id: String(this.emission.id) }})
    },
    deleteButtonClickEvent () {
      // 削除前に再度APIから排出事業者情報を取得し、削除可能か確認する
      this.fetchEmission({ id: this.$route.params.id }).then((content) => {
        if (content.destroyable) {
          this.$refs.confirm.showDeleteConfirm().then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              this.deleteEmission({id: this.emission.id }).then(() =>{
                this.$router.push({name: 'DriverMasterEmissions'})
              })
            }
          })
        } else {
          // 既にマニフェストに利用済み・招待済みの場合の確認
          let modalOption = { title: '削除', message: '既にマニフェストに利用済み・招待済みですが削除しますか？', options: { titleColor: 'red' } }
          this.$refs.confirm.open(modalOption).then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              let params = { logical: true }
              this.deleteEmission({id: this.emission.id, params: params }).then(() =>{
                this.$router.push({name: 'DriverMasterEmissions'})
              })
            }
          })
        }
      })
    },
    changePage (page) {
      this.locationPage = page
      this.searchEmissionLocations()
    },
    emissionChangePage (page) {
      this.userPage = page
      this.searchEmissionUsers()
    },
    entryPatternPageChangeEvent (page) {
      this.entryPatternPage = page;
      this.searchEntryPatterns();
    },
    /**
     * 排出事業場検索
     */
    searchEmissionLocations () {
      this.fetchEmissionLocations({ emission_id: this.$route.params.id , page: this.locationPage}).then((content) => {
        this.emissionLocations = content.locations
        this.locationPagination = content.pagination
      })
    },
    /**
     * 担当者検索
     */
    searchEmissionUsers () {
      this.fetchEmissionUsers({ emission_id: this.$route.params.id , page: this.userPage}).then((content) => {
        this.emissionUsers = content.users
        this.userPagination = content.pagination
      })
    },
    searchEntryPatterns () {
      this.fetchEntryPatterns({ id: this.$route.params.id, page: this.entryPatternPage }).then((content) => {
        this.entryPatterns = content.entry_patterns;
        this.entryPatternPagination = content.pagination
      })
    },
  }
}
</script>

<style lang="scss">

</style>
